import React, { useState, useCallback } from "react";
import { Modal, Checkbox } from "antd";
import { useMediaQuery } from "@mui/material";
import "./termsandconditionmodal.scss"; // import the CSS below

export const TermsModal = ({ visible, onAccept, onCancel }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [termsChecked, setTermsChecked] = useState(false);

  const handleOk = useCallback(() => {
    onAccept();
    setTermsChecked(false);
  }, [onAccept]);

  const handleCancel = useCallback(() => {
    onCancel();
    setTermsChecked(false);
  }, [onCancel]);

  return (
    <Modal
      title="Terms &amp; Conditions"
      visible={visible}
      onCancel={handleCancel}
      width={1340}
      bodyStyle={{
        height: isMobile ? "70vh" : "60vh",
        overflowY: "auto",
        padding: isMobile ? "0px 18px 15px 18px" : "0px 23px 15px 23px",
      }}
      className="termsandconditionModal"
      footer={
        <div className="border-top-0 d-block text-center px-2 d-flex justify-content-between">
          {!isMobile && (
            <Checkbox
              checked={termsChecked}
              onChange={(e) => setTermsChecked(e.target.checked)}
              className="d-flex checkBoxAgreee px-0"
            >
              I agree to the Terms &amp; Conditions of Meri Sehat
            </Checkbox>
          )}
          <button
            disabled={!termsChecked}
            className="buttonModal"
            onClick={handleOk}
          >
            Continue
          </button>
        </div>
      }
    >
      <div className="tm-body-text">
        <p>
          Welcome to Meri Sehat. By partnering with us, you agree to the
          following terms and conditions that govern your collaboration with
          Meri Sehat. We look forward to achieving success together by enhancing
          patient care and streamlining your practice.
        </p>
        <h4>1. Patient Care</h4>
        <ul>
          <li>
            Provide professional care and maintain high standards for all
            patients referred by Meri Sehat. Please note that patient reviews
            will impact your profile on our platform.
          </li>
          <li>
            Avoid charging any additional fees to patients referred by Meri
            Sehat. Only the pre-agreed consultation fees are applicable.
          </li>
        </ul>
        <h4>2. Appointment Management</h4>
        <ul>
          <li>
            Utilize the "Out of Office" feature to manage your availability on
            our platform effectively.
          </li>
          <li>
            Inform us if you need to take leave by calling our support at
            111-111-111 to ensure smooth coordination.
          </li>
        </ul>
        <h4>3. Billing and Payments</h4>
        <ul>
          <li>
            You will receive a monthly bill for all attended patients, with
            payments processed within 5-7 days after billing.
          </li>
          <li>
            Payouts will include cancellation deductions if applicable, with
            details available in your billing/invoice module.
          </li>
          <li>
            For any billing concerns or discrepancies, please reach out to us at
            help@merisehat.pk.
          </li>
        </ul>
        <h4>4. Fees and Charges</h4>

        <div className="d-flex justify-content-center align-items-center">
          <table className="tm-table">
            <thead>
              <tr>
                <th>Patient Type</th>
                <th>Consultation Type</th>
                <th>Commission</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>New Patient</td>
                <td>In-person/Online</td>
                <td>25%</td>
              </tr>
              <tr>
                <td>Existing Patient/Follow-up</td>
                <td>Online</td>
                <td>15%</td>
              </tr>
              <tr>
                <td>Existing Patient/Follow-up</td>
                <td>In-person</td>
                <td>0%</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ul>
          <li>
            All patient payments will be transferred to you at the end of each
            month.
          </li>
          <li>
            Patients are required to pay an advance fee before booking any
            online consultations.
          </li>
        </ul>

        <h4>5. Benefits and Services Provided by Meri Sehat</h4>
        <ul>
          <li>
            You will earn 75% of fees from new patient consultations and retain
            100% of fees from follow-up consultations for in-person
            consultations.
          </li>
          <li>
            Access Meri Sehat’s telemedicine platform to reach international
            patients through online consultations.
          </li>
          <li>
            Gain visibility to millions of patients on Meri Sehat’s website and
            app, enhancing your online presence.
          </li>
          <li>
            Improve your digital footprint with a recognizable profile that
            appears on Google searches.
          </li>
          <li>
            Access to a 24/7-hour call center service to support appointment
            bookings made by patients.
          </li>
          <li>
            Receive comprehensive patient management and telemedicine software
            to facilitate your practice operations.
          </li>
        </ul>

        <p>
          By collaborating with Meri Sehat, you agree to adhere to these terms
          and conditions. We are dedicated to supporting your practice and
          helping you reach a broader patient base. For further inquiries,
          please feel free to contact us at help@merisehat.pk.
        </p>

        {isMobile && (
          <Checkbox
            checked={termsChecked}
            onChange={(e) => setTermsChecked(e.target.checked)}
            className="d-flex checkBoxAgreee px-0"
          >
            I agree to the Terms &amp; Conditions of Meri Sehat
          </Checkbox>
        )}
      </div>
    </Modal>
  );
};
